import { useState } from 'react'
import { Api } from '../api'

interface Props {
  token: string
}

export default function ConfirmPasswordResetPage({ token }: Props) {
  const [password, setPassword]               = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [error, setError]                     = useState<string | null>(null)
  const [loading, setLoading]                 = useState(false)

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (password !== confirmPassword) {
      setError('Passwords do not match')
      return
    }
    setError(null)
    setLoading(true)
    try {
      await Api.passwordResetConfirm({ passwordResetConfirmRequest: { token, password } })
      window.location.href = '/'
    } catch {
      setError('Failed to reset password. The link may be invalid or expired.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-ink-950 flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center mb-8">
          <img src="/bear_icon_transparent.svg" alt="" className="h-16 w-auto brightness-150 mb-4" />
          <h1 className="font-display font-black text-2xl tracking-widest text-bear uppercase leading-none">
            Kodiak Labs
          </h1>
          <p className="font-mono text-[10px] tracking-[0.25em] text-ink-300 uppercase mt-1">
            Set new password
          </p>
        </div>

        <form onSubmit={handleSubmit} className="bg-ink-800 rounded-2xl border border-ink-600/50 p-6 space-y-4">
          <div>
            <label className="block font-mono text-[10px] tracking-[0.2em] uppercase text-ink-200 mb-1.5">
              New Password
            </label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              className="w-full bg-ink-900 border border-ink-600 rounded-lg px-3 py-2.5
                font-mono text-sm text-ink-100 placeholder-ink-500
                focus:outline-none focus:border-bear/60 transition-colors"
              placeholder="••••••••"
              autoComplete="new-password"
              required
              minLength={8}
            />
          </div>
          <div>
            <label className="block font-mono text-[10px] tracking-[0.2em] uppercase text-ink-200 mb-1.5">
              Confirm New Password
            </label>
            <input
              type="password"
              value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
              className="w-full bg-ink-900 border border-ink-600 rounded-lg px-3 py-2.5
                font-mono text-sm text-ink-100 placeholder-ink-500
                focus:outline-none focus:border-bear/60 transition-colors"
              placeholder="••••••••"
              autoComplete="new-password"
              required
              minLength={8}
            />
          </div>
          {error && (
            <p className="font-mono text-[10px] text-coral">{error}</p>
          )}
          <button
            type="submit"
            disabled={loading}
            className="w-full px-4 py-2.5 rounded-xl bg-bear text-ink-50
              font-mono text-[11px] tracking-[0.15em] uppercase font-semibold
              hover:bg-bear-light transition-colors cursor-pointer
              disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? 'Resetting…' : 'Reset password'}
          </button>
        </form>
      </div>
    </div>
  )
}
